import { axiosApi } from "../../../../../api/dbAxios";

export const fetchPdfFile = async (fileUrl: string) => {
  try {
    const response = await axiosApi.get(fileUrl, {
      responseType: "blob",
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Error fetching PDF file", error);
    throw error;
  }
};
